
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公司管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.name" placeholder="输入公司名称"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label=""> -->
      <!-- <el-input size="small" v-model="formInline.deptNo" placeholder="输入公司代码"></el-input> -->
      <!-- </el-form-item> -->
      <el-form-item>
        <!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加轮播</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="url" label="图片" width="210">
        <template #default="scope">
          <div class="demo-image__preview">
            <el-image
              :preview-teleported="true"
              style="width: 100%; height: 100%"
              :src="scope.row.url"
              :zoom-rate="1.2"
              :preview-src-list="[scope.row.url]"
              :initial-index="4"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="title" label="公司标题" width="300">
      </el-table-column>

      <el-table-column sortable prop="content" label="公司内容" width="300">
      </el-table-column>

      <el-table-column sortable prop="btnContent" label="按钮文字" width="150">
      </el-table-column>

      <el-table-column sortable prop="path" label="跳转路径" width="210">
      </el-table-column>
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination> -->

    <el-pagination
      class="page-box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="pageparm.index"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageparm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageparm.total"
    >
    </el-pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="轮播图标题" prop="title">
          <el-input
            size="small"
            v-model="editForm.title"
            auto-complete="off"
            placeholder="请输入轮播图标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="轮播图内容" prop="content">
          <el-input
            size="small"
            v-model="editForm.content"
            auto-complete="off"
            placeholder="请输入轮播图内容"
          ></el-input>
        </el-form-item>

        <el-form-item label="按钮文字" prop="btnContent">
          <el-input
            size="small"
            v-model="editForm.btnContent"
            auto-complete="off"
            placeholder="请输入按钮文字"
          ></el-input>
        </el-form-item>

        <el-form-item label="跳转路径" prop="path">
          <el-input
            size="small"
            v-model="editForm.path"
            auto-complete="off"
            placeholder="请输入跳转路径"
          ></el-input>
        </el-form-item>

        <el-form-item label="关联公司">
          <el-select
            class="company"
            @change="changeCompany"
            v-model="editForm.name_id"
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in conpmanyOptions"
              :key="item.name_id"
              :label="item.name"
              :value="item.name_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="轮播图" prop="url">
          <el-upload
            class="avatar-uploader"
            action="http://106.15.199.41:8088/imgs"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="轮播图" prop="url">
          <el-upload
            class="avatar-uploader"
            :action="imgsUploadUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from "../../components/Pagination";
import {
  getBannerList,
  getCompanyList,
  addBanner,
  updateBanner,
  delBanner,
} from "../../api/newApis";
import { API_BASE } from "@/config/apiBase";
export default {
  computed: {
    imgsUploadUrl() {
      return `${API_BASE}/imgs`;
    },
  },
  data() {
    return {
      conpmanyOptions: null,
      imageUrl: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      keyEdit: false,
      editForm: {
        title: "",
        content: "",
        btnContent: "",
        path: "",
        url: "",
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入公司代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        name: "",
        // varLable: '',
        // varName: '',
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getBannersList();
    this.getCompant();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    async getCompant() {
      const res = await getCompanyList();
      this.conpmanyOptions = res.data;
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      console.log("resresres", res);
      // console.log("this.imageUrl", this.imageUrl);
      this.editForm.url = res.data;
    },
    beforeAvatarUpload(file) {
      console.log("filefilefilefile", file);
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      const typeList = ["jpg", "jpeg", "png", "gif"];
      let fileType = file.name.split(".").slice(-1)[0].toLowerCase();
      if (typeList.indexOf(fileType) === -1) {
        this.$message.error("图片格式只能为jpg/jpeg/png/gif");
        return false;
      }

      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },

    changeCompany(val) {
      console.log("===", val);
      let res;
      if (val.length == 1) {
        res = val[0] + "";
      } else {
        res = val.join(",") + "";
      }
      this.nameArr = res;
      console.log(this.nameArr);
    },

    handleSizeChange(val) {
      console.log(this.pageparm);
      this.pageparm.pageSize = val;
      this.getBannersList();
      // this.$emit('callFather', this.pageparm)
    },

    handleCurrentChange(val) {
      console.log(this.pageparm);
      this.pageparm.index = val;
      this.getBannersList();
    },

    // 获取公司列表
    // getdata(parameter) {
    //   this.loading = true
    //   // 模拟数据
    //   let res = {
    //     code: 0,
    //     msg: null,
    //     count: 5,
    //     data: [
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521062371000,
    //         editTime: 1526700200000,
    //         deptId: 2,
    //         deptName: '上海分公司',
    //         deptNo: '1',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1521063247000,
    //         editTime: 1526652291000,
    //         deptId: 3,
    //         deptName: '上海测试',
    //         deptNo: '02',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526349555000,
    //         editTime: 1526349565000,
    //         deptId: 12,
    //         deptName: '1',
    //         deptNo: '11',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526373178000,
    //         editTime: 1526373178000,
    //         deptId: 13,
    //         deptName: '5',
    //         deptNo: '5',
    //         parentId: 1
    //       },
    //       {
    //         addUser: null,
    //         editUser: null,
    //         addTime: 1526453107000,
    //         editTime: 1526453107000,
    //         deptId: 17,
    //         deptName: 'v',
    //         deptNo: 'v',
    //         parentId: 1
    //       }
    //     ]
    //   }
    //   this.loading = false
    //   this.listData = res.data
    //   // 分页赋值
    //   this.pageparm.currentPage = this.formInline.page
    //   this.pageparm.pageSize = this.formInline.limit
    //   this.pageparm.total = res.count
    //   // 模拟数据结束

    //   /***
    //    * 调用接口，注释上面模拟数据 取消下面注释
    //    */
    //   // deptList(parameter)
    //   //   .then(res => {
    //   //     this.loading = false
    //   //     if (res.success == false) {
    //   //       this.$message({
    //   //         type: 'info',
    //   //         message: res.msg
    //   //       })
    //   //     } else {
    //   //       this.listData = res.data
    //   //       // 分页赋值
    //   //       this.pageparm.currentPage = this.formInline.page
    //   //       this.pageparm.pageSize = this.formInline.limit
    //   //       this.pageparm.total = res.count
    //   //     }
    //   //   })
    //   //   .catch(err => {
    //   //     this.loading = false
    //   //     this.$message.error('菜单加载失败，请稍后再试！')
    //   //   })

    // },
    async getBannersList(params) {
      console.log(22222222, params);
      let param = {
        name_id: "",
      };
      let res = await getBannerList(param);
      console.log("res", res);
      this.listData = res;
      this.pageparm.total = res.length;
      console.log(this.listData);
      // this.pageparm.total = res.data.total
      // this.pageparm.pageSize = res.data.pageSize
      // this.pageparm.index = res.data.index
    },
    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      // this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getBannersList(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      console.log("row", row);
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.keyEdit = true;
        this.title = "修改";
        this.editForm.title = row.title;
        this.editForm.content = row.content;
        this.editForm.btnContent = row.btnContent;
        this.editForm.path = row.path;
        this.editForm.url = row.url;
        this.editForm.id = row.id;
        this.editForm.nameId = row.nameId;
      } else {
        this.imageUrl = "";
        this.editForm = {
          title: "",
          content: "",
          btnContent: "",
          path: "",
          url: "",
        };
        this.keyEdit = false;
        this.title = "添加";
        // this.editForm.name = "";
        this.editForm.nameId = "";
        // this.editForm.deptNo = ''
      }
    },
    // 新增
    async submitForm() {
      console.log(5555555, this.editForm);
      console.log("this.nameArr", this.nameArr);
      console.log(5555555, this.editForm);
      if (this.title == "添加") {
        this.editForm.nameId = this.nameArr;
        let res = await addBanner(this.editForm);
        console.log(33333333, res);
        if (res == "成功") {
          // if (res.code == 200) {
          this.$message.success("新增成功!");
          this.getBannersList();
          this.editFormVisible = false;
          this.loading = false;
        } else {
          this.$message.error(res);
        }
      } else {
        this.editForm.nameId = this.nameArr;
        let res = await updateBanner(this.editForm);
        console.log(33333333, res);

        // if (res.code == 200) {
        if (res == "成功") {
          this.$message.success("修改成功!");
          this.getBannersList();
          this.editFormVisible = false;
          this.loading = false;
        } else {
          this.$message.error(res);
        }
      }
    },

    // 编辑
    // async submitEditForm(){
    //   let res = await addCompanyList(this.editForm)
    //   console.log(33333333,res);
    //   if(res.code == 200) {
    //     this.$message.success("新增成功!")
    //     this.editFormVisible = false
    //     this.loading = false
    //   }else{
    //     this.$message.error(res.msg)
    //   }
    // },

    // 编辑、增加页面保存方法
    // submitForm(editData) {
    //   this.$refs[editData].validate(valid => {
    //     console.log(editData,333333);
    //     if (valid) {
    //       addCompanyList(this.editForm)
    //         .then(res => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           console.log(2222,res);

    //           if (res.success) {
    //             this.getCompanyList()
    //             this.$message({
    //               type: 'success',
    //               message: '公司保存成功！'
    //             })
    //           } else {
    //             this.$message({
    //               type: 'info',
    //               message: res.msg
    //             })
    //           }
    //         })
    //         .catch(err => {
    //           this.editFormVisible = false
    //           this.loading = false
    //           this.$message.error('公司保存失败，请稍后再试！')
    //         })
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // 删除公司
    deleteUser(index, row) {
      console.log("row", row);
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          // let res = await delBanner(row.name_id + "");
          let res = await delBanner(row.id + "");
          // if (res.code == 200) {
          if (res == "成功") {
            this.$message.success("删除成功");
            this.getBannersList();
          } else {
            this.$message.error(res);
          }
        })
        .catch(() => {
          this.$message.error("已取消删除");
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/banner/index.vue